import React, { useState } from "react";
import styled from "styled-components";

const ProductImages = (props: any) => {
  const { className, images } = props;

  const [main, setMain] = useState(images[0]);
  return (
    <Wrapper className={className}>
      <RowContainer>
        <div className="thumbnails">
          {images.map((image: string, index: number) => {
            return (
              <img
                src={image}
                alt={image}
                key={index}
                onMouseDown={() => setMain(images[index])}
                className={`${image === main ? "active" : null}`}
              />
            );
          })}
        </div>
        <div className="full">
          <img src={main} alt="main" className="main" />
        </div>
      </RowContainer>
    </Wrapper>
  );
};

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Wrapper = styled.section`
  width: 40vw;

  .main {
    box-shadow: 0 0 13px 0 rgba(176, 172, 172, 0.5);
    max-height: 100%;
    max-width: 100%;
  }

  .full {
    height: 800px;
    flex: auto;
  }

  .thumbnails {
    flex: 1;
  }

  img {
    width: 100%;
    display: block;
    object-fit: contain;
  }
  .thumbnails {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 800px;
    margin-right: 2rem;
    img {
      width: 120px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
    }
  }
  .active {
    border: 1px solid #565656;
  }
`;

export default ProductImages;
